import Commons from "oc-commons/Commons.js";

export default class Interval2 {

    static parse(string) {
        if (Commons.isEmpty(string)) {
            return null;
        }
        const groups = string.match(/^(\s*[+-]?\d+(?:\.\d+)?)\s*(?:[-]\s*([+-]?\d+(?:\.\d+)?)\s*)?$/);
        const interval = groups.slice(1).map(x=>parseFloat(x));
        return new Interval2(...interval);

    }

    min=undefined;
    max=undefined;

    constructor(min,max=undefined) {
        if (min==null) {
            throw "min value must be set";
        }
        this.min=min;
        this.max=max;
    }

    includes(number,epsilon=0.000001) {
        if (this.max==null) {
            return Math.abs(this.min-number)<epsilon;
        }
        return this.min<=number && number<=this.max;
    }


    /**
     *
     * @param another {Interval2}
     * @returns {boolean}
     */
    intersects(another,epsilon=0.000001){
        return this.includes(another.min,epsilon) || this.includes(another.max,epsilon) || another.includes(this.min,epsilon) || another.includes(this.max,epsilon);
        return true;
    }

    toString() {
        if (this.max==null) {
            return ''+this.min;
        }
        return this.min+' - '+this.max;
    }

}
